/**
 * EU uses non-ISO country code for Greece
 * https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2#Imperfect_implementations
 */
export default function euCode() {
    return function(isoCode) {
        return (isoCode === 'GR') ? 'EL' : isoCode;
    };
}



// WEBPACK FOOTER //
// ./forms/filters/eu-code.js